import { connect } from 'react-redux';

import InstallerTableWrapperComponent from
  './../Components/InstallerTableWrapperComponent.jsx';
import {
  installerFiles as installerFileActions,
  modal as modalActions
} from './../actions';
import {
  getInstallerExpanded,
  getBuildPageInstallerFileMetrics
} from './../reducers';
import { installer } from './../helpers';

export const mapStateToProps = (state) => {
  const metrics = getBuildPageInstallerFileMetrics(state);
  const badge = installer.getInstallerBadge(metrics);
  return {
    expanded: getInstallerExpanded(state),
    panelStyle: badge.style
  };
};

export default connect(
  mapStateToProps,
  {
    setExpanded: installerFileActions.setInstallerExpanded,
    showTestsExpectedModal: modalActions.showTestsExpectedModal
  }
)(InstallerTableWrapperComponent);


// WEBPACK FOOTER //
// src/Containers/InstallerTableWrapperContainer.jsx